import UserTable from "../components/User/UserTable";

function HomePage() {
  return (
    <div>
      <UserTable />
    </div>
  );
}

export default HomePage;
